import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Input } from "@/components/ui/input";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const DeleteAccountSection = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    setLoading(true);
    try {
      await api.post("/auth/delete-account", { password });
      toast.success("Your account and files have been deleted");
      logout();
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mt-14 border border-red-200 p-6" data-testid="delete-account-section">
      <h2 className="text-lg font-bold tracking-tight mb-1">Delete account</h2>
      <p className="text-sm text-[#52525B] mb-4">
        Permanently removes your account, logos, files and history. Payment records are kept for tax purposes. Unlocked logos can't be restored.
      </p>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button type="button" data-testid="delete-account-btn"
            className="border border-red-600 text-red-600 hover:bg-red-600 hover:text-white text-xs uppercase tracking-[0.2em] font-bold h-11 px-6 transition-colors duration-200">
            Delete my account
          </button>
        </AlertDialogTrigger>
        <AlertDialogContent className="rounded-none" data-testid="delete-account-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Delete your account for good?</AlertDialogTitle>
            <AlertDialogDescription>This can't be undone. Enter your password to confirm.</AlertDialogDescription>
          </AlertDialogHeader>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Your password"
            className="rounded-none h-11" data-testid="delete-account-password-input" />
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none" data-testid="delete-account-cancel-btn">Cancel</AlertDialogCancel>
            <button type="button" onClick={confirm} disabled={!password || loading} data-testid="delete-account-confirm-btn"
              className="bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white text-xs uppercase tracking-[0.2em] font-bold h-10 px-5">
              {loading ? "Deleting…" : "Delete forever"}
            </button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
